export default __webpack_public_path__ + "static/media/Group 91.836f510b.svg";